module.exports = __webpack_public_path__ + "img/elemento_pc_up.ffecc4c7.svg";